'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalCarWash = function MdLocalCarWash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 21.6h23.2l-2.5-7.5h-18.2z m20.7 8.4q1.1 0 1.8-0.7t0.7-1.8-0.7-1.8-1.8-0.7-1.7 0.7-0.8 1.8 0.8 1.8 1.7 0.7z m-18.2 0q1 0 1.7-0.7t0.8-1.8-0.8-1.8-1.7-0.7-1.8 0.7-0.7 1.8 0.7 1.8 1.8 0.7z m20.7-16.6l3.4 10v13.2q0 0.7-0.5 1.3t-1.1 0.5h-1.8q-0.7 0-1.1-0.5t-0.5-1.3v-1.6h-20v1.6q0 0.7-0.5 1.3t-1.1 0.5h-1.7q-0.8 0-1.2-0.5t-0.5-1.3v-13.2l3.4-10q0.6-1.8 2.5-1.8h18.2q1.9 0 2.5 1.8z m-20-5q-1 0-1.7-0.8t-0.8-1.7q0-0.7 0.7-1.9t1.2-1.9l0.6-0.8q2.5 2.9 2.5 4.6 0 1-0.7 1.7t-1.8 0.8z m8.4 0q-1.1 0-1.8-0.8t-0.7-1.7q0-0.7 0.6-1.9t1.3-1.9l0.6-0.8q2.5 2.9 2.5 4.6 0 1-0.7 1.7t-1.8 0.8z m8.4 0q-1.1 0-1.8-0.8t-0.7-1.7q0-0.7 0.6-1.9t1.2-1.9l0.7-0.8q2.5 2.9 2.5 4.6 0 1-0.8 1.7t-1.7 0.8z' })
        )
    );
};

exports.default = MdLocalCarWash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-car-wash.js
// module id = 1628
// module chunks = 168707334958949